import React from 'react'
import {Typography,Button, Grid, Divider} from '@mui/material';
import colors from '../../../colors'
import { useSelector, useDispatch } from 'react-redux';
import ArrowBackIosNewIcon from '@mui/icons-material/ArrowBackIosNew';
import { selectUtilityState, displayInvoiceList, changeConfirmationDialogState, displayMainUtilityView, clearUtilitySliceStateForBasicAccount, setIsTransactionSuccessfullyStarted, setScaRequired, setIsScaCompleted } from '../../../../features/utilities/utilitySlice';
import { selectBasicAccountState, setShouldBasicAccountPaymentRun, setTransactionIdToCancel} from '../../../../features/basicAccount/basicAccountSlice';
import {selectGlobalDataState, setGeneralMessage} from '../../../../features/global/globalDataSlice'
import {selectUserInfo} from '../../../../features/userInfo/userInfoSlice'
import {sendGeneralRequest} from '../../../../features/generalRequest'
import { determineTransactionRequest } from './DetermineTransactionRequest'
import Iframe from 'react-iframe'
import {runBasicAccountPayment} from '../../../general/BasicAccountMethods'
import ConfirmationDialog from '../../../general/ConfirmationDialog'
import { texts } from '../../../general/texts';
import { useEffect } from 'react';
import { useHistory, useLocation, useNavigate } from 'react-router-dom';
import { displayOneMainUtilityView } from '../../../../features/oneMobile/oneSlice';

const SingleExpandedInvoice = (props) => 
{
    const utilitySliceState = useSelector(selectUtilityState)
    const basicAccountSliceState = useSelector(selectBasicAccountState)
    const globalDataSliceState = useSelector(selectGlobalDataState)
    const userInfoSliceState = useSelector(selectUserInfo)
    const dispatch = useDispatch()
    const state = props.invoice //?
    const transactionRequest = determineTransactionRequest(utilitySliceState.pin, props.utilityName, globalDataSliceState.token, props.invoice, utilitySliceState, props.transID, '', props.isRegistered) 
    const navigate = useNavigate();
    const location = useLocation();
    const [isConfirming, setIsConfirming] = React.useState(false);


    const handleButtonClick = () => 
    {
        props.utilityName === "ABISSNET" || props.utilityName === 'Siguracione' || props.utilityName === 'TAKSAT_DURRES' || props.utilityName === 'TAKSAT_SHKODER' ||  props.utilityName === "KREDO" ||  props.utilityName === "NOA" ||  props.utilityName === "SIGURIIME_MOTORRIKE" || props.utilityName === "ESIM_99"
            ? dispatch(changeConfirmationDialogState()) 
            :
            dispatch(sendGeneralRequest({request: transactionRequest.startTransaction, baseUrlKey:'services', endpoint:transactionRequest.endpoints.start})) 
    }

    const handleInvoiceBackButtonClick = () => 
    {
        utilitySliceState.sentFrom === 'contractList' ? dispatch(displayInvoiceList()) : props.utilityName === "TELEKOM ALBANIA" ? dispatch(displayOneMainUtilityView(true)) : (props.utilityName === "KREDO" || props.utilityName === "NOA" || props.utilityName === "SIGURIIME_MOTORRIKE" || props.utilityName === "ESIM_99") ? navigate(-1) : dispatch(displayMainUtilityView())
    }
    const handleConfirmation = () => 
        {
            setIsConfirming(true);
            if (props.utilityName === "TELEKOM ALBANIA"){
                dispatch(sendGeneralRequest({
                    request: {token: props.globalDataSliceState.token, transID: props.oneSliceState.transactionId},
                    baseUrlKey:'services',
                    endpoint: 'ASBS/ConfirmONEInvoices'
                })).then(response => {
                    if(response){
                        dispatch(changeConfirmationDialogState(false));
                        dispatch(displayOneMainUtilityView(true));
                    }
                }).finally(() => setIsConfirming(false));
            } else {
                dispatch(sendGeneralRequest({
                    request: transactionRequest.confirmTransaction,
                    baseUrlKey:'services',
                    endpoint: transactionRequest.endpoints.confirm
                })).then(response => {
                    if(response){
                        dispatch(changeConfirmationDialogState(false));
                    }
                    if ((transactionRequest.endpoints.confirm === "Esim99/ConfirmRegister99Esim" ||
                         transactionRequest.endpoints.confirm === "Esim99/ConfirmRefill99Esim") &&
                        response.payload.response.success) {
                        dispatch(setGeneralMessage({
                            type: 'success',
                            message: 'Paketa e internetit u ble me sukses! Ju lutem ndiqni hapat ne email per te aktivizuar e-sim tuaj.'
                        }));
                    }
                }).finally(() => setIsConfirming(false));
            }
        }
        
    React.useEffect(()=> {
        if(props.utilityName !== "ABISSNET")
        {
            if (utilitySliceState.isScaRequired){
                if (utilitySliceState.isScaCompleted){
                    dispatch(changeConfirmationDialogState())
                    dispatch(setScaRequired(false))
                    dispatch(setIsScaCompleted(false))
                }
            }
            if(utilitySliceState.isTransactionSuccessfullyStarted)
            {
                if(userInfoSliceState.accountType === 3)
                {            
                    dispatch(sendGeneralRequest({request: {token: globalDataSliceState.token, paymentMethod:'2', applicationID: 1, value: utilitySliceState.singleInvoice['Vlera totale'].replace(/[^.\d]/g,''), transID: utilitySliceState.transactionId}, baseUrlKey:'services', endpoint:'startCreditCardPayment'}))
                    dispatch(setTransactionIdToCancel(utilitySliceState.transactionId))
                }
                else
                {
                    if (!utilitySliceState.isScaRequired){
                        dispatch(changeConfirmationDialogState())
                    } 
                }
                dispatch(setIsTransactionSuccessfullyStarted(false))   
            }
        }  
    },[utilitySliceState.isTransactionSuccessfullyStarted, utilitySliceState.isScaDialogOpen, utilitySliceState.isScaCompleted])

    const onBack = () => 
    {
        dispatch(setShouldBasicAccountPaymentRun(false))
    }

    

    useEffect(() => {
        const handleLocationChange = () => {
            dispatch(setShouldBasicAccountPaymentRun(false));
        };

        handleLocationChange(); // Initial call to handle location on mount

        return () => {
            handleLocationChange(); // Call on unmount
        };
    }, [location, dispatch]);


    return(      
        <Grid container justifyContent={'center'} pt={2}> 
           
            { 
                basicAccountSliceState.shouldBasicAccountPaymentRun 
                ? 
                runBasicAccountPayment(
                        dispatch,
                        basicAccountSliceState.basicAccountPaymentUrl,
                        {request: transactionRequest.confirmTransaction, baseUrlKey:'services', endpoint:transactionRequest.endpoints.confirm},
                        {request: {token: globalDataSliceState.token, orderId: (props.utilityName === "KREDO" || props.utilityName === "NOA" || props.utilityName === "SIGURIIME_MOTORRIKE") ? props.transID : utilitySliceState.transactionId}, baseUrlKey:'services', endpoint:'cancelCreditCardPayment'},
                        onBack
                     ) 
                :
                <>
                    <Grid container pb={'3%'}>
                        <Grid item md={2} xs={2} pt={'1%'} ><Button onClick={handleInvoiceBackButtonClick} sx={{height:'4rem', borderRadius:'100%',":hover":{background:colors.white}}} ><ArrowBackIosNewIcon color='warning' /></Button></Grid>
                    </Grid>
                    <Grid container justifyContent={'center'} p={3}>       
                        <Grid container md={12} pb={'10%'} item > 
                            <Divider sx={{width:'100%', marginBottom:'5%', borderStyle:'dashed'}}/>
                            {Object.entries(state).map(([key,value]) => {
                                return <>
                                {key === 'Vlera totale' && <Divider sx={{width:'100%', marginBottom:'5%', borderStyle:'dashed'}}/>}
                                <Grid container item md={12} xs={12} pb={4} >
                                    <Grid container item justifyContent='flex-start' md={6}><Typography style={{color: colors.darkBlue, fontFamily:'GerberaBold', fontSize:'1.9vh'}}>{key}</Typography></Grid>
                                    <Grid container item justifyContent='flex-end' md={6} ><Typography style={{color:key === 'Vlera totale' ? colors.orange : colors.gray ,fontSize:'1.8vh', fontFamily:'GerberaLight'}}>{value}</Typography></Grid>
                                </Grid></> 
                            })}                                                                                                                         
                        </Grid>
                        <Grid container item justifyContent={'center'} pb={'2%'} md={12} >
                            <Button disabled={utilitySliceState.isLoading ? true : false} style={{background:colors.gradientOrange ,width:'100%', color:colors.white,textTransform:'none', fontFamily:'GerberaBold'}} onClick={handleButtonClick}>{texts["title-pay"]}</Button>        
                        </Grid>           
                    </Grid>
                    {(utilitySliceState.isConfirmationDialogOpen) && <ConfirmationDialog handleClose={()=>{dispatch(changeConfirmationDialogState())}} isConfirmationDialogOpen={utilitySliceState.isConfirmationDialogOpen} data={texts["message-confirm-transaction-general"]} handleConfirmationClick={handleConfirmation}/>}      
                </> 
                
            }                                       
        </Grid>             
    )
}
export default SingleExpandedInvoice